import { render, staticRenderFns } from "./AreaCreate.vue?vue&type=template&id=58cb430b&scoped=true"
import script from "./AreaCreate.vue?vue&type=script&lang=js"
export * from "./AreaCreate.vue?vue&type=script&lang=js"
import style0 from "./AreaCreate.vue?vue&type=style&index=0&id=58cb430b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cb430b",
  null
  
)

export default component.exports